'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setWelcomePopupShown = exports.logInAndToIndex = exports.setAuthorizedUser = exports.setAuthorizing = exports.setShownUser = exports.logOut = exports.loggedIn = exports.logIn = undefined;
exports.showWelcomePopup = showWelcomePopup;
exports.setFirstLogin = setFirstLogin;

var _actionTypes = require('../constants/actionTypes');

var _routing = require('../constants/routing');

var _popupTypes = require('../constants/popupTypes');

var _popupActions = require('./popupActions');

/* injects from baggage-loader */

var logIn = exports.logIn = function logIn() {
  return { type: _actionTypes.LOG_IN };
};
var loggedIn = exports.loggedIn = function loggedIn() {
  return { type: _actionTypes.LOGGED_IN };
};
var logOut = exports.logOut = function logOut() {
  return { type: _actionTypes.LOG_OUT };
};

var setShownUser = exports.setShownUser = function setShownUser(value) {
  return { type: _actionTypes.SET_SHOWN_USER, value: value };
};
var setAuthorizing = exports.setAuthorizing = function setAuthorizing(value) {
  return { type: _actionTypes.SET_AUTHORIZING, value: value };
};
var setAuthorizedUser = exports.setAuthorizedUser = function setAuthorizedUser(value) {
  return { type: _actionTypes.SET_AUTHORIZED_USER, value: value };
};
var logInAndToIndex = exports.logInAndToIndex = function logInAndToIndex() {
  return { type: _actionTypes.LOG_IN_AND_TO_INDEX };
};
var setWelcomePopupShown = exports.setWelcomePopupShown = function setWelcomePopupShown(value) {
  return { type: _actionTypes.USER_SET_WELCOME_POPUP_SHOWN, value: value };
};

function showWelcomePopup() {
  return function (dispatch) {
    setTimeout(function () {
      dispatch(setWelcomePopupShown(true));
      dispatch((0, _popupActions.popupShow)(_popupTypes.WELCOME));
    }, 100);
  };
}

var mustShowWelcomePopup = function mustShowWelcomePopup(routeType) {
  return [_routing.JALAN_USER_PROJECT, _routing.JALAN_PROJECT, _routing.JALAN_NODE, _routing.JALAN_USER_NODE].indexOf(routeType) > -1;
};

function setFirstLogin(value) {
  return function (dispatch, getState) {
    var routeType = getState().routing.type;

    dispatch({ type: _actionTypes.USER_SET_FIRST_LOGIN, value: value });

    if (value && mustShowWelcomePopup(routeType)) dispatch(showWelcomePopup());
  };
}


//////////////////
// WEBPACK FOOTER
// ./app/actions/userActions.js
// module id = 49
// module chunks = 1